import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface SUVSelectedIconProps {
  color?: Color;
}

const SUVSelectedIcon: React.FC<SUVSelectedIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_44854)">
      <path
        d="M10.4701 26.48C9.70006 26.4 5.68006 26.05 5.47006 25.03C5.27711 23.0932 5.3039 21.1407 5.55002 19.21C6.08307 17.9634 7.05928 16.9587 8.29001 16.39C13.3508 14.7157 18.6156 13.7367 23.94 13.48C27.0004 11.3828 30.2013 9.49837 33.52 7.83998C34.9268 7.33856 36.3921 7.0193 37.88 6.88998C40.7406 6.47785 43.6308 6.30726 46.52 6.37999C50.63 6.37999 63.63 8.08997 63.63 8.37997C63.63 8.66997 63.2 8.80998 62.77 8.89998C62.69 9.14998 69.1 13.6 69.19 13.77C69.28 13.94 70.3001 16 69.3601 16.77C69.4754 17.7041 69.7037 18.6209 70.04 19.5C70.13 19.67 70.9 20.19 70.9 20.7C70.9 21.21 71.41 24.29 68.76 25.49C67.7221 25.8962 66.6236 26.126 65.51 26.17L10.4701 26.48Z"
        fill={color}
        stroke={color}
        strokeWidth="0.75"
      />
      <path d="M26.2 25.53L49.55 25.28" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M8.33002 19.04C8.74915 18.4965 9.23643 18.0091 9.77997 17.59C11.0792 17.2061 12.4253 17.0042 13.78 16.99C13.87 16.99 14.04 17.16 13.95 17.24C13.4005 17.9586 12.7223 18.5689 11.95 19.04C11.6 19.13 9.04 19.13 8.44 19.21C8.33 19.21 8.33002 19.13 8.33002 19.04Z"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M70.43 15.95L69.7401 15.19C69.5473 14.999 69.3152 14.8523 69.06 14.76L65.81 14.68C66.2577 15.6268 66.7689 16.5422 67.34 17.42C68.0732 17.3419 68.7928 17.167 69.48 16.9L70.48 16.52"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M60.93 12.8C60.93 12.8 49.64 13.57 42.28 13.8C34.92 14.03 26.46 14.49 26.46 14.49"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M43.57 8.10001L42.28 13.83"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.32 8.70001L56.06 13.06"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M22.55 25.12C22.5826 25.2013 22.6093 25.2849 22.6299 25.37C22.8446 26.0686 22.9194 26.8027 22.85 27.5302C22.7807 28.2578 22.5686 28.9645 22.2259 29.61C21.8832 30.2555 21.4165 30.8271 20.8527 31.2921C20.2889 31.7571 19.6389 32.1064 18.94 32.32C18.2375 32.5392 17.4985 32.6174 16.7657 32.5498C16.0329 32.4823 15.3207 32.2705 14.6701 31.9266C14.0195 31.5827 13.4432 31.1135 12.9747 30.546C12.5061 29.9785 12.1545 29.324 11.94 28.62C11.5097 27.2077 11.6577 25.6824 12.3515 24.3792C13.0453 23.076 14.2281 22.1016 15.6399 21.67C16.8548 21.2948 18.1621 21.3514 19.34 21.83"
        fill={color}
      />
      <path
        d="M22.55 25.12C22.5826 25.2013 22.6093 25.2849 22.6299 25.37C22.8446 26.0686 22.9194 26.8027 22.85 27.5302C22.7807 28.2578 22.5686 28.9645 22.2259 29.61C21.8832 30.2555 21.4165 30.8271 20.8527 31.2921C20.2889 31.7571 19.6389 32.1064 18.94 32.32C18.2375 32.5392 17.4985 32.6174 16.7657 32.5498C16.0329 32.4823 15.3207 32.2705 14.6701 31.9266C14.0195 31.5827 13.4432 31.1135 12.9747 30.546C12.5061 29.9785 12.1545 29.324 11.94 28.62C11.5097 27.2077 11.6577 25.6824 12.3515 24.3792C13.0453 23.076 14.2281 22.1016 15.6399 21.67C16.8548 21.2948 18.1621 21.3514 19.34 21.83"
        stroke="white"
        strokeWidth="0.75"
      />
      <path
        d="M62.84 25.12C62.84 25.2 62.84 25.28 62.92 25.37C63.3502 26.7823 63.2023 28.3076 62.5085 29.6108C61.8147 30.914 60.6319 31.8884 59.22 32.32C58.5176 32.5406 57.7782 32.6198 57.045 32.5529C56.3117 32.486 55.599 32.2744 54.9481 31.9303C54.2971 31.5863 53.7209 31.1165 53.2526 30.5483C52.7843 29.9801 52.4334 29.3247 52.22 28.62C51.7898 27.2077 51.9377 25.6824 52.6315 24.3792C53.3253 23.076 54.5081 22.1016 55.92 21.67C57.1348 21.2948 58.442 21.3514 59.6199 21.83"
        fill={color}
      />
      <path
        d="M62.84 25.12C62.84 25.2 62.84 25.28 62.92 25.37C63.3502 26.7823 63.2023 28.3076 62.5085 29.6108C61.8147 30.914 60.6319 31.8884 59.22 32.32C58.5176 32.5406 57.7782 32.6198 57.045 32.5529C56.3117 32.486 55.599 32.2744 54.9481 31.9303C54.2971 31.5863 53.7209 31.1165 53.2526 30.5483C52.7843 29.9801 52.4334 29.3247 52.22 28.62C51.7898 27.2077 51.9377 25.6824 52.6315 24.3792C53.3253 23.076 54.5081 22.1016 55.92 21.67C57.1348 21.2948 58.442 21.3514 59.6199 21.83"
        stroke="white"
        strokeWidth="0.75"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_44854">
        <rect width="66.35" height="26.94" fill="white" transform="translate(5 6)" />
      </clipPath>
    </defs>
  </svg>
);

export default SUVSelectedIcon;
